module.exports = __webpack_public_path__ + "static/media/skybtdp.e19ec7f5.jpg";